'use client';

import type { useSortable } from '@dnd-kit/sortable';
import type { Ref } from 'react';
import { cn } from '@savvy-kit/lib/utils';
import { GripVertical } from 'lucide-react';

// Derive from the hook's return shape — avoids @dnd-kit's internal dist/ type paths.
type Sortable = ReturnType<typeof useSortable>;

type DragHandleProps = {
  readonly attributes: Sortable['attributes'];
  readonly listeners: Sortable['listeners'];
  readonly label: string;
  readonly className?: string;
  /** Pass for a dedicated activator handle (`setActivatorNodeRef`); omit when the button is itself the sortable. */
  readonly ref?: Ref<HTMLButtonElement>;
};

/** Grip for @dnd-kit sortables; callers layer position and hover/focus visibility via `className`. */
export function DragHandle({ attributes, listeners, label, className, ref }: DragHandleProps) {
  return (
    <button
      type="button"
      ref={ref}
      {...attributes}
      {...listeners}
      aria-label={label}
      className={cn(
        'flex size-5 cursor-grab touch-none items-center justify-center rounded text-secondary hover:bg-component-hover active:cursor-grabbing',
        className,
      )}
    >
      <GripVertical className="size-4" aria-hidden="true" />
    </button>
  );
}
